"use strict";

var _regeneratorRuntime = require("/Users/owise1/Dropbox/Os/computers/freelance/Clients/MWright/ambient/fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var regeneratorRuntime = require("regenerator-runtime");

var handleUrl = function () {
  var a = _asyncToGenerator(_regeneratorRuntime.mark(function b(c) {
    var d, e;
    return _regeneratorRuntime.wrap(function (g) {
      for (;;) {
        switch (g.prev = g.next) {
          case 0:
            return g.next = 2, fetch(c).catch(function () {
              return Promise.reject(new Error("Error fetching data"));
            });

          case 2:
            return d = g.sent, g.next = 5, d.json().catch(function () {
              return log("Error parsing server response"), Promise.reject(new Error("Error parsing server response"));
            });

          case 5:
            if (e = g.sent, "OK" !== e.status) {
              g.next = 9;
              break;
            }

            return log(e), g.abrupt("return", e);

          case 9:
            return log("Server returned status code " + e.status, !0), g.abrupt("return", Promise.reject(new Error("Server returned status code " + e.status)));

          case 11:
          case "end":
            return g.stop();
        }
      }
    }, b, this);
  }));

  return function () {
    return a.apply(this, arguments);
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: !0
});

function _asyncToGenerator(a) {
  return function () {
    var b = a.apply(this, arguments);
    return new Promise(function (c, d) {
      function e(f, g) {
        try {
          var h = b[f](g),
              i = h.value;
        } catch (j) {
          return void d(j);
        }

        return h.done ? void c(i) : Promise.resolve(i).then(function (j) {
          e("next", j);
        }, function (j) {
          e("throw", j);
        });
      }

      return e("next");
    });
  };
}

var DEBUG = !1,
    API_KEY = null,
    GOOGLE_API = "https://maps.google.com/maps/api/geocode/json";

function log(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 && arguments[1];
  DEBUG && (b ? console.warn(a) : console.log(a));
}

exports.default = {
  setApiKey: function setApiKey(a) {
    API_KEY = a;
  },
  enableDebug: function enableDebug() {
    var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : !0;
    DEBUG = a;
  },
  fromLatLng: function fromLatLng(a, b, c) {
    var d = this;
    return _asyncToGenerator(_regeneratorRuntime.mark(function e() {
      var f, g;
      return _regeneratorRuntime.wrap(function (i) {
        for (;;) {
          switch (i.prev = i.next) {
            case 0:
              if (a && b) {
                i.next = 3;
                break;
              }

              return log("Provided coordinates are invalid", !0), i.abrupt("return", Promise.reject(new Error("Provided coordinates are invalid")));

            case 3:
              return f = a + "," + b, g = GOOGLE_API + "?latlng=" + encodeURI(f), (c || API_KEY) && (API_KEY = c || API_KEY, g += "&key=" + API_KEY), i.abrupt("return", handleUrl(g));

            case 7:
            case "end":
              return i.stop();
          }
        }
      }, e, d);
    }))();
  },
  fromAddress: function fromAddress(a, b) {
    var c = this;
    return _asyncToGenerator(_regeneratorRuntime.mark(function d() {
      var e;
      return _regeneratorRuntime.wrap(function (g) {
        for (;;) {
          switch (g.prev = g.next) {
            case 0:
              if (a) {
                g.next = 3;
                break;
              }

              return log("Provided address is invalid", !0), g.abrupt("return", Promise.reject(new Error("Provided address is invalid")));

            case 3:
              return e = GOOGLE_API + "?address=" + encodeURI(a), (b || API_KEY) && (API_KEY = b || API_KEY, e += "&key=" + API_KEY), g.abrupt("return", handleUrl(e));

            case 6:
            case "end":
              return g.stop();
          }
        }
      }, d, c);
    }))();
  }
};